import React, {useEffect, useState} from "react";
import "./BasketInvoice.scss";
import {useHistory, useLocation} from "react-router-dom";
import {CheckinMallAuth, getAccessToken_api, getOrderDetail_api} from "../../Services/apis";
import {useDispatchMall, useDispatchUser} from "../../hooks";


let mock = {
    "uid": "nAGrCwzZ38",
    "client_invoice_id": null,
    "merchant": {
        "uid": "tfmxFxMrd2",
        "name": "فست فود نمونه",
        "cover": null,
        "thumbnail": null,
        "mall": {
            "uid": "SfM7Cg7Mub",
            "name": "فست فود نمونه",
            "about_us": null,
            "english_name": "fastfoodnemoone",
            "description": "",
            "image": "https://test-loyalty-minio.darkube.app/loyalty-media/campaign/campaign/images/restu-11_8NVMhIR.png",
            "header_image": "https://test-loyalty-minio.darkube.app/loyalty-media/mall/mall/header_images/restu-10_GR0Ehw8.png",
            "thumbnail": "https://test-loyalty-minio.darkube.app/loyalty-media/campaign/campaign/images/restu-10_mdyWLrv.png",
            "logo": "https://test-loyalty-minio.darkube.app/loyalty-media/mall/mall/logos/restu-11.png",
            "cover": "https://test-loyalty-minio.darkube.app/loyalty-media/campaign/campaign/images/restu-05.png",
            "order": 1,
            "is_featured": false,
            "enable": true,
            "created": "2022-09-05T16:20:19.741947+04:30",
            "payment_sdk_client_id": null,
            "show_map": false,
            "is_chain_store": false,
            "notification_message": ""
        },
        "address": "",
        "online_merchant": true,
        "see_more": ""
    },
    "address": null,
    "amount": 1500000,
    "discount_amount": 150000,
    "client_discount_amount": 0,
    "discount_amount_sum": 150000,
    "discount_sum_on_products": 0,
    "payable_amount": 1350000,
    "state": "success_to_pay",
    "paid_at": "2022-11-20T09:07:32.422622+03:30",
    "purchase_token": null,
    "description": null,
    "products": [
        {
            "product": {
                "uid": "nyty9ny7Kk",
                "name": "مانتو",
                "price_original": 1500000,
                "price": 1500000,
                "stock": 1000000000,
                "is_available": true,
                "image": null,
                "barcode": "1003"
            },
            "name": "مانتو",
            "quantity": 1,
            "amount": 1500000,
            "payable_amount": 1500000,
            "per_amount": 1500000
        }
    ],
    "rewards": [
        {
            "uid": "DuUswf6Gjm",
            "merchant": {
                "uid": "tfmxFxMrd2",
                "name": "فست فود نمونه",
                "cover": null,
                "thumbnail": null,
                "address": "",
                "online_merchant": true
            },
            "campaign_title": "جشنواره تخفیف",
            "effect": {
                "uid": "QSd98aEePa",
                "title": "تخفیف درصد",
                "effect": "real_time_discount_percent",
                "value": "10",
                "coupon_template": null,
                "created": "2022-11-02T12:18:38.059647+03:30"
            },
            "values": null,
            "generated_coupon": null,
            "is_uncertain": false,
            "is_consumed": true,
            "description": "تخفیف درصد",
            "consume_date": "2022-11-20T05:37:30.405902Z",
            "created": "2022-11-20T09:07:30.299031+03:30"
        },
        {
            "uid": "sMBxQuGbTE",
            "merchant": {
                "uid": "tfmxFxMrd2",
                "name": "فست فود نمونه",
                "cover": null,
                "thumbnail": null,
                "address": "",
                "online_merchant": true
            },
            "campaign_title": "جشنواره امتیاز",
            "effect": {
                "uid": "xDax7u48UB",
                "title": "فود کارت",
                "effect": "increase_card_campaign_points",
                "value": "10",
                "coupon_template": null,
                "created": "2022-10-30T14:46:38.362885+03:30"
            },
            "values": {
                "point": {
                    "type": "int",
                    "value": 10
                }
            },
            "generated_coupon": null,
            "is_uncertain": false,
            "is_consumed": true,
            "description": "فود کارت",
            "consume_date": "2022-11-20T05:37:32.583986Z",
            "created": "2022-11-20T09:07:30.298933+03:30"
        }
    ],
    "created": "2022-11-20T09:07:29.996348+03:30",
    "payment_method": "online",
    "payment_type": 0
}

function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}


function OnlineSubCatCard({cat,merchantId}) {
    //hooks
    const history = useHistory();

    return(
        <div className="online-sub-categories-item" >
            <div className="info-section" onClick={()=>{
                history.push(`/online-store-product/${merchantId}/${cat.uid}`)
            }}>
                <span>{cat.name}</span>
                <div className="price-section">
                    <span  className="original-price">{numberWithCommas(cat.price_original)} </span>
                    <span style={{direction:"rtl"}} className="price">{numberWithCommas(cat.price)}  ریال </span>
                </div>
            </div>
            <div className="img-section" onClick={()=>{
                history.push(`/online-store-product/${merchantId}/${cat.uid}`)
            }}>
                <img src={cat.image?cat.image:"/other/skeleton/product.jpg"} alt=""/>
                {/*{cat && cat.discount_percentage!==0?*/}
                {/*    <div className="off">*/}
                {/*        {cat.discount_percentage+" % "}*/}
                {/*    </div>:*/}
                {/*    null*/}
                {/*}*/}

            </div>
        </div>
    )
}


let token = "";
let userId = "";
let orderId = "";
let merchantParamId = "";


function BasketInvoice() {

    const history = useHistory();
    const [total , set_total] = useState(0);
    const [off , set_off] = useState(0);
    const [price , set_price] = useState(0);
    const [basket , set_basket] = useState(0);
    const [order , set_order] = useState(0);
    const [merchantId , set_merchantId] = useState("merchantId");
    const [merchant , set_merchant] = useState({});
    const [status,setStatus] = useState("default");

    const setUser = useDispatchUser();
    const setMall = useDispatchMall();
    const location = useLocation();



    useEffect(()=>{
        // set_basket(mock.products);
    },[])

    useEffect(() => {
        let search = new URLSearchParams(location.search)
         token = search.get('token');
         userId = search.get('user_uid');
         orderId = search.get('order_uid');
         merchantParamId = search.get('merchant_uid');
         let login = localStorage.getItem('token');
         if(!login)
            getAccess(userId, token)
        else
             getOrderDetail()

    }, [])



    const getAccess = async (u,t)=>{

        //validation
        if(!u || !t  )
            return setStatus("error")

        let obj = {
            token: t,
            user_uid: u
        }

        try{
            const res = await getAccessToken_api(obj)
            console.log("res : ",res)
            //set token to localstorage
            localStorage.setItem('token',res.data.access_token);
            localStorage.setItem('shop_token',res.data.access_token);
            localStorage.setItem('user',JSON.stringify(res.data));
            setUser(res.data);
            getOrderDetail()
            //checkin user to mall
            // let checkin = await CheckinMallAuth(m)
            // localStorage.setItem('mallId',checkin.data.place_uid);
            // localStorage.setItem('mallLogo',checkin.data.place_header_image);
            // localStorage.setItem('mallName',checkin.data.place_name);
            // localStorage.setItem('mall',JSON.stringify(checkin.data));
            // let mallObj ={
            //     uid : checkin.data.place_uid,
            //     english_name: checkin.data.place_english_name,
            //     name: checkin.data.place_name,
            //     description: checkin.data.place_description,
            //     header_image: checkin.data.place_header_image,
            // }
            //
            // setMall(mallObj);

        }catch(e){
            setStatus("error")
            console.log(e)
        }
    }

    const getOrderDetail = async ()=>{
        try{
            const res = await getOrderDetail_api(orderId)
            set_basket(res.data.items)
            set_order(res.data)
            set_total(res.data.original_amount)
            set_off(res.data.discount)
            set_price(res.data.amount)
        }catch (e) {
            console.log(e)
        }
    }

    return(
        <>
            <div className="basket-brand" onClick={()=>{history.push(`/online-style-shop/${merchantId}`)}}>
                <img src={merchant.thumbnail} alt=""/>
            </div>
            <div className="online-basket-container">
                <div className="online-header-section">
                    <i className="fa fa-arrow-left"
                       onClick={()=>{
                           history.goBack()
                       }}
                    ></i>
                    <span>سبد اقلام</span>
                </div>
                {basket?.length> 0? <div className="basket-info-section">
                    <div className="total-section">
                        <span> {numberWithCommas(total)} ریال </span>
                        <span>مجموع</span>
                    </div>
                    <div className="off-section">
                        <span> {numberWithCommas(off)} ریال </span>
                        <span>مجموع تخفیف اقلام</span>
                    </div>
                    <div className="price-section">
                        <span> {numberWithCommas(price)} ریال </span>
                        <span>مبلغ قابل پرداخت</span>
                    </div>
                </div>:null}

                <div className="online-sub-categories-container">
                    {basket.length <1?
                        <div className="cartEmpty">
                            <span>محصولی در سبد موجود نمی باشد</span>
                        </div>
                        :null}
                    {basket && basket.map(item=>{
                        return(
                            <OnlineSubCatCard cat={item.product}  merchantId={merchantId}/>
                        )
                    })}
                    <div className="desc-section">
                        <p>{order?.description}</p>
                    </div>
                </div>
                <div className="online-product-footer">
                    <div className="notAdded-mode">
                        <div className="add-to-basket-btn" onClick={()=>{
                            history.push("/send-info-invoice",{order,merchantParamId})
                        }}>
                            <span>ادامه فرایند خرید</span>
                        </div>
                    </div>
                </div>
            </div>
            </>
    )
}

export {BasketInvoice};
